// extracted by mini-css-extract-plugin
export default {"textHeading":"services_textHeading__9Lnj6","servText":"services_servText__TKpx8","mainDiv":"services_mainDiv__xddQK"};